import {getOrDefault} from "@/components/LayoutMaps/maps/MapFunction";

const state = {
    mapData: [],
    filter: []
};
const getters = {};
const actions = {
    unpackData(context, data) {
        let result = [];
        let filter = [];
        for (let area of data) {
            let name = getOrDefault('workshopCode', area, '')
            let type = getOrDefault('machineType', area, '')
            let workers = Array.from(area.workers);
            let projectCodes = Array.from(area.projectCodes);
            let stopTasks = Array.from(area.stopTasks);
            let tasks = Array.from(area.tasks);
            let colorValue = type === "0" ? 0 : getOrDefault('workshopStatus', area, 1);
            let toDoOperations = '';
            if (colorValue === 1 && workers.length === 0) {
                if (getOrDefault('hasOperationToDo', area, false)) {
                    colorValue = 5;
                    toDoOperations = area.toDoOperations ? '<br/>计划工序：<br/>' + area.toDoOperations.join('<br/>') : '';
                } else {
                    colorValue = 4;
                }
            }
            result.push({
                name: name,
                type: type,
                value: colorValue,
                label: getOrDefault('workshopName', area, ''),
                workers: workers.length > 0 ? '<br/>在岗人员：' + workers.join('，') : '',
                projectCodes: projectCodes.length > 0 ? '<br/>项目号：' + projectCodes.join('，') : '',
                stopTasks: stopTasks.length > 0 ? '<br/>红灯问题：<br/>' + stopTasks.join('<br/>') : '',
                tasks: tasks.length > 0 ? '<br/>黄灯问题：<br/>' + tasks.join('<br/>') : '',
                toDoOperations: toDoOperations,
            });
            if (type === "0") {
                filter.push(name);
            }
        }
        context.commit('setMapData', result);
        context.commit('setFilter', filter);
    }
};
const mutations = {
    setMapData(state, val) {
        state.mapData = val;
    },
    setFilter(state, val) {
        state.filter = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
